import {
	Component,
	Input
}                             from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import { StringUtils }        from '@utils/helpers';

/**
 * Meant to render some status value.
 * NOTE: For the component to work properly for a given status, this status has
 * to be listed in the `$statusColors` map in the _branding-colors.scss, and in
 * the i18n maps under `shared.status`. In both maps, the key of the map entry
 * has to be the <u>value</u> of the corresponding status enum constant.
 */
@Component( {
	selector: 'app-status-text[status]',
	templateUrl: './status-text.component.html',
	styleUrls: [ './status-text.component.scss' ]
} )
export class StatusTextComponent {

	private _status: string;
	sanitizedStatus: string;

	@Input() set status( status: string ) {
		if ( status === this._status ) { return; }
		this._status = status;
		this.init();
	}

	@Input() i18nPath: string;
	@Input() showSpare = false;
	@Input() textWrappingIsAllowed = false;

	constructor(
		private readonly translationService: TranslationService
	) {}

	private sanitizeToCamelCase( str: string ): string {
		// return as lowercase only when all chars ar uppercase
		if ( str.match( /^[A-Z]*$/ ) ) {
			return str.toLowerCase();
		}

		// prepends all uppercase chars with '_'
		str = str?.replace(
			/[A-Z]/g,
			( match: string, offset: number, fullString: string ) => {
				return `_${ fullString?.charAt( offset ) }`;
			}
		);

		// converts string to camelCase
		return StringUtils.toCamelCase( str );
	}

	init(): void {
		if ( this._status ) {
			this.sanitizedStatus = this.sanitizeToCamelCase( this._status );
		}
	}

	getI18nString( i18nPath ): string {
		const spare: string = this.showSpare ? '-' : '';
		if ( !i18nPath ) { return spare; }

		return this.translationService.getI18nString( false, null, i18nPath, true, spare );
	}
}
